/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { FieldsetComponent } from '../../fieldset/fieldset.component';

@Component({
  selector: 'ods-form-checkbox-group',
  template: `
    <ods-fieldset [name]="legend" [legend]="legend" [legendId]="legendId">
      <div role="group" [attr.aria-labelledby]="legendId">
        <ul class="m-0 flex list-none flex-col gap-2 p-0">
          <ng-content />
        </ul>
      </div>
    </ods-fieldset>
  `,
  imports: [FieldsetComponent],
})
export class FormCheckboxGroupComponent {
  @Input({ required: true }) legend: string;

  public readonly legendId: string = uniqueId('form-checkbox-group-legend-');
}
